import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface OfflineReasonsTableProps {
}

export const OfflineReasonsTable: React.FC<OfflineReasonsTableProps> = () => {

    const offlineReasonsState = useAppSelector(state => state.offlineReasons);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Nimi</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {offlineReasonsState.offlineReasons.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row.name}
                            </td>
                            <td className="action">
                                <Link to={`/offline-reasons/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/offline-reasons/${row.id}/delete`}>Kustuta</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <ul className="table-actions">
                <li>
                    <Link to="/offline-reasons/new">
                        <strong>Lisa uus põhjus</strong>
                    </Link>
                </li>
            </ul>
        </>
    );

}